import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@mui/material';
import Select from 'components/select';
import { useRecoilState } from 'recoil';
import { OrderPayload } from 'pages/myidm/store';
import ProvisioningStyles from 'pages/provisioning/vm/style';
import { endPoints } from 'api/endpoints';
import axios from 'api/request';
import { useMutation } from 'react-query';

const DomainType = ({ index }) => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(OrderPayload);
    const [options, setOptions] = React.useState([]);
    const domainTypesApi = useMutation(() => axios.get(endPoints.myIdm.domainTypes));

    const currentValue = index !== undefined ? order?.multipleResourceGroups?.[index]?.domainType : order?.domainType;

    const setDomainType = (domainType) => {
        const updatedGroups = [...(order?.multipleResourceGroups || [])];
        updatedGroups[index] = {
            ...updatedGroups[index],
            domainType,
        };
        setOrder({
            ...order,
            multipleResourceGroups: updatedGroups,
        });
    };

    const handleOnSelectChange = (selected) => {
        setDomainType(selected.value);
    };

    const resetOptions = () => {
        setOptions([]);
    };

    React.useEffect(() => {
        if (domainTypesApi?.isSuccess) {
            setOptions(
                (domainTypesApi?.data?.data || [])
                    // ?.filter((domainType) => domainType !== 'cwwpvt')
                    ?.map((domainType) => ({
                        label: domainType,
                        value: domainType,
                    }))
            );
        }
    }, [domainTypesApi?.isSuccess]);

    React.useEffect(() => {
        resetOptions();
        domainTypesApi.mutate();
    }, []);

    React.useEffect(() => {
        if (!currentValue && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [currentValue, order?.isTouched]);

    return (
        <Stack direction="row" spacing={1} sx={ProvisioningStyles.stack}>
            <Select
                sx={{ marginTop: 0 }}
                key={`domain-type-${index !== undefined ? index : 'single'}`}
                label="Domain Type *"
                value={options.find((option) => option.value === currentValue) || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isRequired={isTouched}
                disabled={domainTypesApi.isLoading}
                isLoading={domainTypesApi.isLoading}
                isOptionEqualToValue={(option, selectedValue) => option.value === selectedValue.value}
            />
        </Stack>
    );
};

DomainType.propTypes = {
    index: PropTypes.number,
};

DomainType.defaultProps = {
    index: undefined,
};

export default DomainType;
